import { PrivateInterceptorsPR } from "../../../Base/interceptors/PrivateinterceptorsPR";

export const getCurrencyIPS = async () => {
    const result = await PrivateInterceptorsPR(`Global/Currency/currencyIPS`, 'GET');
    return result;
}
